import React from 'react';
import {
  HeroContent,
  HeroImage,
} from '@sls-react/components/Homepage/Elements';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import useTileVersion from '@sls-react/hooks/useTileVersion';
import BlockButton from '@sls-react/components/legos/BlockButton';

interface Props {
  block: RailsBlock;
}

const SingleBlock: React.FC<Props> = ({ block }) => {
  const tileVersion = useTileVersion(block);

  const heroContent = (
    <HeroContent className="less-shadow">
      <HeroImage
        alt={block.title}
        css={`
          z-index: -1;
        `}
        src={tileVersion.background_image_url}
      />

      <h2
        className="px-4 font-bold text-center"
        css={`
          color: ${tileVersion.text_color || '#fff'};
        `}
      >
        {tileVersion.title}
      </h2>

      {tileVersion.button_text && <BlockButton block={block} />}
    </HeroContent>
  );

  return (
    <div className="mb-4 md:mb-8">
      {tileVersion.destination && !tileVersion.button_text ? (
        <a href={tileVersion.destination}>{heroContent}</a>
      ) : (
        heroContent
      )}
    </div>
  );
};

export default SingleBlock;
